import type { ThemeWithLookSystem } from "@/types/look-system";

/**
 * The one gate for the look system: without it every renderer path must stay today's path, byte for byte.
 * The CMS's `isRewebLookSystem` uses the same rule, so keep the two identical.
 */
export function isLookSystem(theme: unknown): theme is ThemeWithLookSystem {
  return (
    typeof (theme as { colorSystem?: { version?: unknown } } | null | undefined)
      ?.colorSystem?.version === "number"
  );
}
